import React, { useContext } from 'react';
import c from 'classnames';
import { Trans, useTranslation } from 'react-i18next';

import GasIcon from '@hvcgroep/design-system/assets/illustrations/Gas.svg';
import HeatIcon from '@hvcgroep/design-system/assets/illustrations/Warmte.svg';

import ModalContext from '../../contexts/ModalContext';
import { Row } from '../../helpers/costsTable';
import Table from '../Table';

import './style.scss';

interface Props {
  title?: string;
  data: Row[];
  className?: string;
  showAnnualCVCost?: boolean;
  showCVMaintenanceCost?: boolean;
}

const CostsTable: React.FC<Props> = ({
  title,
  data,
  className,
  // @TODO - at some point these may be removed see https://uncinc.monday.com/boards/603929811/pulses/8925092145?notification=6153221354
  // @TODO - when this is reverted the checks in the cypress test should be turned on again as well
  showAnnualCVCost = false,
  showCVMaintenanceCost = false,
}) => {
  const { t } = useTranslation();
  const { updateModalOpen } = useContext(ModalContext);

  const classNames = c(
    'CostsTable',
    className,
  );
  // Filter out the rows based on the showAnnualCVCost and showCVMaintenanceCost props
  const filteredData = data.filter((row) => ((!showAnnualCVCost && row.id !== 'annual_cv_cost') && (!showCVMaintenanceCost && row.id !== 'cv_maintenance_cost')));

  return (
    <div className={classNames}>
      <h2 className="h3">{title}</h2>
      <Table
        data={!showAnnualCVCost && !showCVMaintenanceCost ? filteredData : data}
        header={(
          <tr className="header">
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <td />
            <th>
              <img src={GasIcon} alt="" />
              {t('heat_calculator.costs_table.titles.gas')}
            </th>
            <th>
              <img src={HeatIcon} alt="" />
              {t('heat_calculator.costs_table.titles.heat')}
            </th>
          </tr>
        )}
      />
      <div className="CostsTable__info">
        <p>
          <Trans>
            {t('heat_calculator.costs_table.info.calculation')}
          </Trans>
          <a
            href="/"
            role="button"
            onClick={(evt) => {
              evt.preventDefault();
              updateModalOpen(true);
            }}
          >
            {t('heat_calculator.costs_table.link')}
          </a>
        </p>
        <p>
          <Trans>
            {t('heat_calculator.costs_table.info.cv_maintenance')}
          </Trans>
        </p>
      </div>
    </div>
  );
};

export default CostsTable;
